import { useState, useEffect } from 'react';
import assignmentAttachmentServices from 'ApiService/Placement/assignmentAttachmentServices';
import AttachmentPreview from './AttachmentPreview';
import UploadForm from './UploadForm';

const SharedFilesPanel = ({ assignmentId }) => {
  const [attachments, setAttachments] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchAttachments = async () => {
    if (!assignmentId) return;
    setLoading(true);
    try {
      const res = await assignmentAttachmentServices.getAttachmentsByAssignment(assignmentId);
      if (res.data.success) setAttachments(res.data.data);
    } catch {
      // silent
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAttachments();
  }, [assignmentId]);

  const handleDeleted = (id) => {
    setAttachments((prev) => prev.filter((a) => a._id !== id));
  };

  const handleUploaded = (data) => {
    const items = Array.isArray(data) ? data : [data];
    setAttachments((prev) => [...items, ...prev]);
  };

  return (
    <div>
      <h4 className="mb-2 text-sm font-semibold text-gray-700 dark:text-gray-300">
        Shared Files for Student
      </h4>

      {loading ? (
        <p className="text-sm text-gray-500">Loading...</p>
      ) : attachments.length > 0 ? (
        <div className="mb-3 space-y-2">
          {attachments.map((att) => (
            <AttachmentPreview key={att._id} attachment={att} onDelete={handleDeleted} isHR />
          ))}
        </div>
      ) : (
        <p className="mb-3 text-sm text-gray-500">No files shared yet.</p>
      )}

      <UploadForm assignmentId={assignmentId} onUploaded={handleUploaded} />
    </div>
  );
};

export default SharedFilesPanel;
